import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Parallax } from 'react-parallax'

import { SectionContainer, SectionText, SectionTitle } from '../../_common'
import { Grid } from '@material-ui/core'

const getInfo = graphql`
  {
    bgImg: file(relativePath: { eq: "building.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 4160) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`

const Purpose = () => {
  const { bgImg } = useStaticQuery(getInfo)

  return (
    <Parallax strength={300} bgImage={bgImg.childImageSharp.fluid.src}>
      <SectionContainer sectionID="purpose" backgroundColor="transparent">
        <Grid container>
          <Grid item sm={4}></Grid>
          <Grid item sm={8}>
            <SectionTitle title="Nuestro propósito" />
            <SectionText text="Proporcionar un servicio de consultoría con altos estándares profesionales, asesorando en todo momento a nuestros clientes y socios sobre las soluciones adecuadas a sus objetivos de negocio, planes de crecimiento y necesidades a largo plazo, cumpliendo con el marco legal contable y fiscal de maneta estricta y con una confidencialidad absoluta en el manejo de la información." />
          </Grid>
        </Grid>
      </SectionContainer>
    </Parallax>
  )
}

export default Purpose
